import axios from "axios";
import qs from 'qs';
import jwt_decode from "jwt-decode";

const urlPurchaseOrders = window.VUE_APP_PURCHASEORDERS_API_URL;
const urlcontacts = window.VUE_APP_CONTACTS_API_URL;
const urlcompanies = window.VUE_APP_COMPANIES_API_URL;
const urlSuppliers = window.VUE_APP_SUPPLIERS_API_URL;
const urlCustomers = window.VUE_APP_CUSTOMERS_API_URL;
const urlInvoices = window.VUE_APP_INVOICES_API_URL;
const urlSecurity = window.VUE_APP_SECURITY_API_URL;
const urlProducts = window.VUE_APP_PRODUCTS_API_URL;
const urlDelivries = window.VUE_APP_DELIVRIES_API_URL;
const urlNotifications = window.VUE_APP_NOTIFICATIONS_API_URL;

axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.post["Access-Control-Allow-Methods"] = "GET, PUT, POST, DELETE, OPTIONS, post, get";
axios.defaults.headers.post["Access-Control-Max-Age"] = "3600";
axios.defaults.headers.post["Access-Control-Allow-Headers"] = "Origin, Content-Type, X-Auth-Token";
axios.defaults.headers.post["Access-Control-Allow-Credentials"] = true;

var idCompanyFromToken;
var idSupplierFromToken;
var idDeliveryFromToken;

VerifToken();

export function VerifToken() {
    try {
        var decodedToken = jwt_decode(GetToken());
        var currentTimeStamp = Math.floor(Date.now() / 1000);
        if (currentTimeStamp > decodedToken.exp) {
            logout();
        }
        idCompanyFromToken = decodedToken.CompanyId;
        idSupplierFromToken = decodedToken.SupplierId;
        idDeliveryFromToken = decodedToken.DeliveryCompanyId;
    } catch (error) {
        logout();
    }
}

export function formatPrice(price) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
    }).format(price);
}

export function GetToken() {
    return localStorage.getItem("accessToken");
}

export function isClient() {
    if (idCompanyFromToken == null) return false;
    return idCompanyFromToken != "00000000-0000-0000-0000-000000000000";
}

export function isSupplier() {
    if (idSupplierFromToken == null) return false;
    return idSupplierFromToken != "00000000-0000-0000-0000-000000000000";
}

export function isDelivery() {
    if (idDeliveryFromToken == null) return false;
    return idDeliveryFromToken != "00000000-0000-0000-0000-000000000000";
}

export function idClient() {
    return idCompanyFromToken;
}

export function idSupplier() {
    return idSupplierFromToken;
}

export function idDelivery() {
    return idDeliveryFromToken;
}

export function logout() {
    localStorage.clear();
    sessionStorage.clear();
}

axios.defaults.headers.common["Authorization"] = "Bearer " + GetToken();

export function login(user) {
    return axios.post(urlcontacts + "/api/Account/Authenticate", user);
}

export function loginDelivery(user) {
    let User = {
        EmailOrPhoneNumber: user.email,
        Password: user.password
    }
    return axios.post(urlDelivries + "/api/Open/AuthenticateAdmin", User);
}

export function SendResetPasswordMail(email) {
    return axios.get(urlcontacts + "/api/Account/SendResetPasswordMail?mail=" + email);
}

export function register(registerData) {
    return axios.post(urlcompanies + "/api/Companies", registerData);
}

export function SendEmailConfirmationCode(email) {
    return axios.get(urlcontacts + "/api/Account/SendEmailConfirmationCode?mail=" + email);
}

export function EmailConfirmation(Email, VerificationCode) {
    return axios.post(urlcontacts + "/api/Account/EmailConfirmation?mail=" + Email + "&code=" + VerificationCode);
}

export function resetPassword(ResetPasswordKey, password) {
    return axios.post(urlcontacts + "/api/Account/ResetPassword?ResetPasswordCode=" + ResetPasswordKey,
        { password: password, }
    );
}

export function ExistUserMail(email) {
    return axios.get(urlcontacts + "/api/user/ExistEmail/" + email);
}

export function ActivateAccount(ActivateAccountKey, password) {
    return axios.post(urlcontacts + "/api/Account/ActivateAccount?ActivateAccountCode=" + ActivateAccountKey,
        { password: password, }
    );
}

/************************  Company  APIs *************************/

export function CheckProfileCompletionCompany() {
    return axios.get(urlcompanies + "/api/CompaniesV2/CheckProfileCompletion");
}

export function CreateCompanyV2(AccountDetails) {
    return axios.post(urlcompanies + "/api/CompaniesV2", AccountDetails);
}

export function getCompany(page, PageSize, CompanyFilters, sortedBy, sortingType) {
    CompanyFilters.SortedBy = sortedBy.toUpperCase();
    CompanyFilters.SortingType = sortingType;
    CompanyFilters.Status != null ? (CompanyFilters.withStatus = true) : false;
    return axios.post(urlcompanies + "/api/Companies/GET?PageNumber=" + page + "&PageSize=" + PageSize,
        { companyFilters: CompanyFilters, }
    );
}

export function getCompanyByFilterName(BrandName) {
    return axios.get(urlcompanies + "/api/Companies/ByFilterName?BrandName=" + BrandName);
}

export function getSupplierClientID() {
    return axios.get(urlSuppliers + "/api/Suppliers/GetSupplierClientID");
}

export function getClientById(idCompany) {
    return axios.get(urlcompanies + "/api/Companies/Client/" + idCompany);
}

export function getCompanyById(idCompany) {
    return axios.get(urlcompanies + "/api/Companies/" + idCompany);
}

export function addCompany(CompanyInfo) {
    return axios.post(urlcompanies + "/api/Companies/Company", CompanyInfo);
}

export function deleteCompany(id) {
    return axios.delete(urlcompanies + "/api/Companies/" + id);
}

export function editCompany(idCompany, dataFromEditCompanies) {
    return axios.put(urlcompanies + "/api/Companies/", dataFromEditCompanies);
}

export function getCompanyByTokenId() {
    return axios.get(urlcompanies + "/api/Companies/companyFromToken");
}

/************************  Company Logo APIs *************************/

export function addlogoCompany(imageName, image) {
    if (imageName == null) imageName = idCompanyFromToken;
    let formData = new FormData();
    formData.append("model", image);
    return axios.post(urlcompanies + "/File/logo?imageName=" + imageName, formData,
        { headers: { "Content-Type": "multipart/form-data" }, }
    );
}

export function getlogoCompany(API, Id) {
    switch (API) {
        case 1:
            return axios.get(urlcompanies + "/File/logo/Client?fileName=" +
                (idCompanyFromToken !== undefined ? idCompanyFromToken : Id),
                { responseType: "arraybuffer" }
            );
        case 2:
            return axios.get(urlSuppliers + `/api/SupplierV2/Logo/${Id}`, {
                responseType: "arraybuffer",
            });
        default:
            return axios.get(urlcompanies + "/File/logo?fileName=" +
                (idCompanyFromToken !== undefined ? idCompanyFromToken : Id),
                { responseType: "arraybuffer" }
            );
    }
}

/********************** Company's Users APIs **********************/

export function getUsers(page, PageSize, UserFilters, sortedBy, sortingType) {
    UserFilters.SortedBy = sortedBy.toUpperCase();
    UserFilters.SortingType = sortingType;
    UserFilters.Status != null ? (UserFilters.withStatus = true) : false;
    return axios.post(urlcompanies + "/api/User/GET?PageNumber=" + page + "&PageSize=" + PageSize,
        UserFilters
    );
}

export function getUserById(idUser) {
    return axios.get(urlcompanies + "/api/User/" + idUser);
}

export function editUser(id, userName, userEmail, regionCoverage, departement, companyID) {
    return axios.put(urlcompanies + "/api/User/" + id, {
        id: id,
        fullName: userName,
        email: userEmail,
        regionCoverage: regionCoverage,
        departmentId: departement,
        companyID: companyID ? companyID : idCompanyFromToken,
    });
}

export function addUser(idCompany, id, userName, email, regionCoverage, departement, role) {
    return axios.post(urlcompanies + "/api/User/", {
        companyID: idCompany ? idCompany : idCompanyFromToken,
        id: id,
        fullName: userName,
        email: email,
        regionCoverage: regionCoverage,
        departmentId: departement,
        role: role,
    });
}

export function deleteUser(id) {
    return axios.delete(urlcompanies + "/api/User/" + id);
}

export function ExistCompanyEmail(email) {
    return axios.get(urlcompanies + "/api/User/ExistCompanyEmail/" + email);
}

export function GetStatusUsers() {
    return axios.get(urlcompanies + "/api/user/GetStatusFromConfiguration/");
}

/********************* Company's Location APIs ********************/
export function getLocation(page, PageSize, locationFilters, sortedBy, sortingType) {
    locationFilters.SortedBy = sortedBy.toUpperCase();
    locationFilters.SortingType = sortingType;
    locationFilters.Status != null ? (locationFilters.withStatus = true) : false;
    return axios.post(urlcompanies + "/api/Locations/GET?PageNumber=" + page + "&PageSize=" + PageSize,
        locationFilters
    );
}

export function getLocationById(idLocation) {
    return axios.get(urlcompanies + "/api/Locations/" + idLocation);
}

export function getAllLocation() {
    var page = 1;
    var PageSize = 99;
    return axios.post(urlcompanies + "/api/Locations/GET?PageNumber=" + page + "&PageSize=" + PageSize,
        { SortedBy: "", SortingType: "ASC" }
    );
}

export function addLocation(idCompany, locationName, address, postalCode, url, city, country) {
    return axios.post(urlcompanies + "/api/Locations", {
        IdCompany: idCompany,
        LocationName: locationName,
        Address: address,
        PostalCode: parseInt(postalCode),
        url: url,
        City: city,
        Status: true,
        Country: country,
    });
}

export function editLocations(idLocation, location) {
    return axios.put(urlcompanies + "/api/Locations/" + idLocation, location);
}

export function deleteLocation(id) {
    return axios.delete(urlcompanies + "/api/Locations/" + id);
}

export function GetStatusLocations() {
    return axios.get(urlcompanies + "/api/Locations/GetStatusFromConfiguration/");
}

/********************* Company's Department APIs ********************/

export function getDepartment(page, PageSize, DepartmentFilters, sortedBy, sortingType) {
    DepartmentFilters.SortedBy = sortedBy.toUpperCase();
    DepartmentFilters.SortingType = sortingType;
    return axios.post(urlcompanies + "/api/Department/GET?PageNumber=" + page + "&PageSize=" + PageSize,
        DepartmentFilters
    );
}

export function getAllDepartment() {
    var page = 1;
    var PageSize = 50;
    return axios.post(urlcompanies + "/api/Department/GET?PageNumber=" + page + "&PageSize=" + PageSize,
        { SortedBy: "", SortingType: "ASC" }
    );
}

export function getRolesByCompany() {
    let SecurityGroupFilters = {};
    var pageNumber = 1;
    var pageSize = 100;
    SecurityGroupFilters.SortedBy = "";
    SecurityGroupFilters.SortingType = "ASC";
    return axios.post(urlSecurity + "/v1/SecurityGroup/ByCompanyID?pageNumber=" + pageNumber + "&pageSize=" + pageSize,
        SecurityGroupFilters
    );
}

export function getRolesBySupplier(idSupplier) {
    let SecurityGroupFilters = {};
    var pageNumber = 1;
    var pageSize = 100;
    SecurityGroupFilters.SortedBy = "";
    SecurityGroupFilters.SortingType = "ASC";
    SecurityGroupFilters.Organisation = idSupplier;
    return axios.post(urlSecurity + "/v1/SecurityGroup/BySupplierID?pageNumber=" + pageNumber + "&pageSize=" + pageSize,
        SecurityGroupFilters
    );
}

export function AddDepartement(DepartmentName, LocationCoverage, idCompany) {
    return axios.post(urlcompanies + "/api/Department", {
        departmentName: DepartmentName,
        idLocation: LocationCoverage,
        idCompany: idCompany,
    });
}

export function getDepartmentById(idDepartment) {
    return axios.get(urlcompanies + "/api/Department/" + idDepartment);
}

export function getDepartmentByName(DepartmentName) {
    return axios.get(urlcompanies + "/api/Department/Name?Name=" + DepartmentName);
}

export function editDepartment(idDepartment, Department) {
    return axios.put(urlcompanies + "/api/Department/" + idDepartment, Department);
}

export function deleteDepartement(idDepartment) {
    return axios.delete(urlcompanies + "/api/Department/" + idDepartment);
}

/********************* Company's Taxe APIs ********************/

export function getTaxes(page, PageSize, TaxFilters, sortedBy, sortingType) {
    TaxFilters.SortedBy = sortedBy.toUpperCase();
    TaxFilters.SortingType = sortingType;
    TaxFilters.Status != null ? (TaxFilters.withStatus = true) : false;
    return axios.post(
        urlcompanies + "/api/Taxes/GET?PageNumber=" + page + "&PageSize=" + PageSize,
        TaxFilters
    );
}

export function AddTaxe(TaxName, TaxPercentage, idCompany) {
    return axios.post(urlcompanies + "/api/Taxes", {
        taxName: TaxName,
        taxPourcentage: TaxPercentage,
        status: true,
        idCompany: idCompany,
    });
}

export function editTaxe(idTaxe, taxe) {
    return axios.put(urlcompanies + "/api/Taxes/" + idTaxe, taxe);
}

export function deleteTaxe(id) {
    return axios.delete(urlcompanies + "/api/Taxes/" + id);
}

export function GetStatusTaxes() {
    return axios.get(urlcompanies + "/api/Taxes/GetStatusFromConfiguration/");
}

export function GetTaxListByCmpanyId(companyId) {
    return axios.get(urlcompanies + "/api/Taxes/GET/" + companyId);
}

/************************ Suppliers APIs *************************/
export function SendForValidation() {
    return axios.put(urlSuppliers + "/api/SupplierV2/ToBeValidated");
}

export function GetSupplierGeneralInformation(idSupplier) {
    return axios.get(urlSuppliers + `/api/SupplierV2/SupplierGeneralInformation/${idSupplier}`);
}
export function GetSupplierInvoicing(idSupplier) {
    return axios.get(urlSuppliers + `/api/SupplierV2/SupplierInvoicing/${idSupplier}`);
}

export function CheckProfileCompletionSupplier() {
    return axios.get(urlSuppliers + "/api/SupplierV2/CheckProfileCompletion");
}

export function CreateSupplierV2(AccountDetails) {
    return axios.post(urlSuppliers + "/api/SupplierV2", AccountDetails);
}


export function getSuppliers(page, pageSize, title, manager, country, paymentCondition, status,
    createdDate, sortedBy, sortingType
) {
    const SuppliersFilters = {};
    if (title !== null) SuppliersFilters.Title = title;
    if (manager !== null) SuppliersFilters.Manager = manager;
    if (country !== null) SuppliersFilters.Country = country;
    if (paymentCondition !== null)
        SuppliersFilters.PaymentCondition = paymentCondition;
    if (status !== null) {
        SuppliersFilters.ValidationStatus = status;
        SuppliersFilters.WithStatus = true;
    }
    if (createdDate !== null) SuppliersFilters.Created = createdDate;
    if (sortedBy !== null) SuppliersFilters.SortedBy = sortedBy.toUpperCase();
    if (sortingType !== null) SuppliersFilters.SortingType = sortingType;

    return axios.post(urlSuppliers + "/api/Suppliers/GET", {
        pageNumber: page,
        pageSize,
        SuppliersFilters,
    });
}

export function getSupplierById(idSupplier) {
    return axios.get(urlSuppliers + "/api/Suppliers/" + idSupplier);
}

export function addSupplier(supplier) {
    return axios.post(urlSuppliers + "/api/Suppliers", {
        name: supplier.name,
        code: supplier.code,
        paymentCondition: supplier.paymentCondition,
        defaultPhone: supplier.defaultPhone,
        delivery: supplier.delivery,
        country: supplier.country,
        city: supplier.city,
        address: supplier.address,
        defaultEmail: supplier.defaultEmail,
        currencies: supplier.currencies,
        postalCode: supplier.postalCode,
        totalMinimumOrder: supplier.totalMinimumOrder,
    });
}

export function editSupplier(idSupplier, dataFromEditSupplier) {
    return axios.put(urlSuppliers + "/api/Suppliers/" + idSupplier,
        dataFromEditSupplier
    );
}


export function editSupplierGeneralInformation(data) {
    let formData = new FormData();
    formData.append("Name", data.Name);
    formData.append("Code", data.Code);
    formData.append("DefaultPhone", data.DefaultPhone);
    formData.append("DefaultEmail", data.DefaultEmail);
    formData.append("Country", data.Country);
    formData.append("City", data.City);
    formData.append("PostalCode", data.PostalCode);
    formData.append("Address", data.Address);
    if (data.logoImage) {
        const logoImage = data.logoImage;
        formData.append("LogoImage", logoImage);
    }

    return axios.put(
        urlSuppliers + "/api/SupplierV2/GeneralInformation",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
    );
}

export function editSupplierInvoicing(data) {
    let formData = new FormData();
    formData.append("ContactPhone", data.InvoicingPhone);
    formData.append("InvoicingMail", data.InvoicingMail);
    formData.append("Delivery", data.Delivery);
    formData.append("TotalMinimumOrder", data.TotalMinimumOrder);
    formData.append("PaymentCondition", data.PaymentCondition);
    formData.append("Currencies", data.Currencies);

    return axios.put(urlSuppliers + "/api/SupplierV2/Invoicing", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function getSupplierLocationlist(page, PageSize, idSupplier,
    LocationName, Address, City, PostalCode, Country, SortedBy, SortingType) {

    let SupplierLocationFilters = {};
    LocationName !== null ? (SupplierLocationFilters.LocationName = LocationName) : delete SupplierLocationFilters.LocationName;
    Address !== null ? (SupplierLocationFilters.Address = Address) : delete SupplierLocationFilters.Address;
    City !== null ? (SupplierLocationFilters.City = City) : delete SupplierLocationFilters.City;
    PostalCode !== null ? (SupplierLocationFilters.PostalCode = PostalCode) : delete SupplierLocationFilters.PostalCode;
    Country !== null ? (SupplierLocationFilters.Country = Country) : delete SupplierLocationFilters.Country;
    SortedBy !== null ? (SupplierLocationFilters.SortedBy = SortedBy.toUpperCase()) : delete SupplierLocationFilters.SortedBy;
    SortingType !== null ? (SupplierLocationFilters.SortingType = SortingType) : delete SupplierLocationFilters.SortingType;

    return axios.post(urlSuppliers + "/api/Locations/GET?PageNumber=" + page + "&PageSize=" + PageSize + "&idSupplier=" + idSupplier,
        SupplierLocationFilters
    );
}

export function addSupplierLocation(data) {
    return axios.post(urlSuppliers + "/api/Locations/", data);
}

export function editSupplierLocation(data) {
    return axios.put(urlSuppliers + "/api/Locations/" + data.idLocation, data);
}

export function deleteSupplierLocation(idLocation) {
    return axios.delete(urlSuppliers + "/api/Locations/" + idLocation);
}

export function getUserlist(page, PageSize, idSupplier,
    FullName, Email, PhoneNumber, Role, SupplierPortal, SortedBy, SortingType) {

    let UsersFilters = {};
    FullName !== null ? (UsersFilters.FullName = FullName) : delete UsersFilters.FullName;
    Email !== null ? (UsersFilters.Email = Email.replace("\t", "")) : delete UsersFilters.Email;
    PhoneNumber !== null ? (UsersFilters.PhoneNumber = PhoneNumber) : delete UsersFilters.PhoneNumber;
    Role !== null ? (UsersFilters.Role = Role) : delete UsersFilters.Role;
    SupplierPortal !== null ? (UsersFilters.SupplierPortal = SupplierPortal) : delete UsersFilters.SupplierPortal;
    SortedBy !== null ? (UsersFilters.SortedBy = SortedBy.toUpperCase()) : delete UsersFilters.SortedBy;
    SortingType !== null ? (UsersFilters.SortingType = SortingType) : delete UsersFilters.SortingType;

    return axios.post(urlSuppliers + "/api/Users/GET", {
        pageNumber: page,
        pageSize: PageSize,
        IdSupplier: idSupplier,
        UsersFilters: UsersFilters,
    });
}

export function getDocumentslist(page, PageSize, idSupplier,
    name, expiryDate, status, createdDate, sortedBy, sortingType) {

    const DocumentsFilters = {};

    if (name !== null) DocumentsFilters.Name = name;
    if (expiryDate !== null) DocumentsFilters.ExpiryDate = expiryDate;
    if (status !== null) {
        DocumentsFilters.Status = status; DocumentsFilters.WithStatus = true;
    }
    if (createdDate !== null) DocumentsFilters.Created = createdDate;
    if (sortedBy !== null) DocumentsFilters.SortedBy = sortedBy.toUpperCase();
    if (sortingType !== null) DocumentsFilters.SortingType = sortingType;

    return axios.post(urlSuppliers + "/api/Documents/GET", {
        pageNumber: page,
        pageSize: PageSize,
        IdSupplier: idSupplier,
        DocumentsFilters: DocumentsFilters,
    });
}

export function deleteDocumentSupplier(idUser) {
    return axios.delete(urlSuppliers + "/api/Documents/" + idUser);
}

export function downloadDocumentSupplier(fileName) {
    return axios.get(urlSuppliers + "/api/Documents/" + fileName);
}

export function editSupplierDocument(id, documentSupplier) {
    let formData = new FormData();
    formData.append("idDocument", documentSupplier.idDocument);
    formData.append("name", documentSupplier.name);
    formData.append("File", documentSupplier.identityDocument ? documentSupplier.identityDocument[0] : null);
    formData.append("expiryDate", documentSupplier.expiryDate);
    formData.append("status", documentSupplier.status);
    formData.append("Type", documentSupplier.type);

    return axios.put(urlSuppliers + "/api/Documents/" + id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function addSupplierDocument(name, identityDocument, expiryDate, idSupplier) {
    let formData = new FormData();
    formData.append("name", name);
    formData.append("File", identityDocument ? identityDocument[0] : null);
    formData.append("expiryDate", expiryDate);
    formData.append("idSupplier", idSupplier);
    return axios.post(urlSuppliers + "/api/Documents", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function GetStatusDocuments() {
    return axios.get(urlSuppliers + "/api/Documents/GetStatusFromConfiguration/");
}

export function editSupplierUser(id, userSupplier) {
    return axios.put(urlSuppliers + "/api/Users/" + id, {
        idUser: userSupplier.idUser,
        fullName: userSupplier.fullName,
        phoneNumber: userSupplier.phoneNumber,
        email: userSupplier.email,
        supplierPortal: userSupplier.supplierPortal,
    });
}

export function addSupplierUser(fullName, phoneNumber, email, supplierPortal, role, idSupplier) {
    return axios.post(urlSuppliers + "/api/Users/", {
        fullName: fullName,
        phoneNumber: phoneNumber,
        email: email,
        supplierPortal: supplierPortal,
        role: role,
        idSupplier: idSupplier,
    });
}

export function deleteSupplierUser(idUser) {
    return axios.delete(urlSuppliers + "/api/Users/" + idUser);
}

export function DeleteSuppliers(idSupplier) {
    return axios.delete(urlSuppliers + "/api/Suppliers/" + idSupplier);
}

export function getBankAccount(PageNumber, PageSize, idSupplier,
    iban, bic, bankName, accountHolderName, identityDocument, SortedBy, SortingType) {
    let bankAccountFilters = {};
    iban !== null ? (bankAccountFilters.iban = iban) : delete bankAccountFilters.iban;
    bic !== null ? (bankAccountFilters.bic = bic) : delete bankAccountFilters.bic;
    bankName !== null ? (bankAccountFilters.bankName = bankName) : delete bankAccountFilters.bankName;
    accountHolderName !== null ? (bankAccountFilters.accountHolderName = accountHolderName) : delete bankAccountFilters.accountHolderName;
    identityDocument !== null ? (bankAccountFilters.identityDocument = identityDocument) : delete bankAccountFilters.identityDocument;
    SortedBy !== null ? (bankAccountFilters.SortedBy = SortedBy.toUpperCase()) : delete bankAccountFilters.SortedBy;
    SortingType !== null ? (bankAccountFilters.SortingType = SortingType) : delete bankAccountFilters.SortingType;
    return axios.post(urlSuppliers + "/api/BankAccount/GET",
        { PageNumber, PageSize, idSupplier, bankAccountFilters }
    );
}

export function addSupplierBankAccount(iban, bic, bankName, agencyName, bankAdresse,
    accountHolderName, identityDocument, identityDocumentPDF, country, idSupplier) {
    let formData = new FormData();
    formData.append("AccountHolderName", accountHolderName);
    formData.append("IBAN", iban);
    formData.append("IdSupplier", idSupplier);
    formData.append("BankName", bankName);
    formData.append("AgencyName", agencyName);
    formData.append("BankAdresse", bankAdresse);
    formData.append("IdentityDocument", identityDocument);
    formData.append("BIC", bic);
    formData.append("Country", country);
    formData.append("File", identityDocumentPDF ? identityDocumentPDF : null);

    return axios.post(urlSuppliers + "/api/BankAccount", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function editSupplierBankAccount(id, BankAccount) {
    let formData = new FormData();
    formData.append("IdBankAccount", BankAccount.idBankAccount);
    formData.append("IBAN", BankAccount.iban);
    formData.append("BIC", BankAccount.bic);
    formData.append("BankName", BankAccount.bankName);
    formData.append("AgencyName", BankAccount.agencyName);
    formData.append("BankAdresse", BankAccount.bankAdresse);
    formData.append("AccountHolderName", BankAccount.accountHolderName);
    formData.append("IdentityDocument", BankAccount.identityDocument);
    formData.append("Country", BankAccount.country);
    formData.append("File", BankAccount.identityDocumentPDF ? BankAccount.identityDocumentPDF : null);
    return axios.put(urlSuppliers + "/api/BankAccount/" + id, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function DeleteSupplierBankAccount(idBankAccount) {
    return axios.delete(urlSuppliers + "/api/BankAccount/" + idBankAccount);
}

export function getIdentityDocument(identityDocument) {
    return axios.get(urlSuppliers + "/api/BankAccount/identityDocument?fileName=" + identityDocument);
}

export function ValidationButton(idSupplier) {
    return axios.get(urlSuppliers + "/api/Suppliers/validationButton/" + idSupplier);
}

export function ValidateSupplier(idSupplier) {
    return axios.put(urlSuppliers + "/api/SupplierV2/validate/" + idSupplier);
}

export function RefuseSupplier(idSupplier, commentaire) {
    return axios.put(urlSuppliers + "/api/SupplierV2/refuse/" + idSupplier + "?comment=" + commentaire);
}

export function ToBeCompleted(idSupplier, commentaire) {
    return axios.put(urlSuppliers + "/api/SupplierV2/tobecompleted/" + idSupplier + "?comment=" + commentaire);
}

export function ExistSupplierMail(email) {
    return axios.get(urlSuppliers + "/api/Users/ExistSupplierEmail/" + email);
}

export function GetStatusSuppliers() {
    return axios.get(urlSuppliers + "/api/Suppliers/GetStatusFromConfiguration/");
}

export function GetTraceValidationListBySupplierId(idSupplier) {
    return axios.get(urlSuppliers + "/api/Suppliers/GetTraceValidationListBySupplierId/" + idSupplier);
}

/************************ Purchase Order APIs *************************/

export function GetAllPurchaseOrders(page, PageSize, reference, company, supplier, status,
    amountHT, amoutTTC, expirationDate, createdDate, SortedBy, SortingType, IsEqual,
    IsGreater, IsLess, HasPermissionValidation
) {
    let PurchaseOrderFilters = {
        IsEqual: IsEqual || undefined,
        IsGreater: IsGreater || undefined,
        IsLess: IsLess || undefined,
        Reference: reference || undefined,
        // Title: title || undefined,
        Company: company || undefined,
        Supplier: supplier || undefined,
        Status: status !== null ? parseInt(status, 10) : undefined,
        withStatus: status !== null ? status !== null : undefined,
        AmountHT: amountHT || undefined,
        Consumption: amoutTTC || undefined,
        ExpirationDate: expirationDate || undefined,
        Created: createdDate || undefined,
        SortedBy: SortedBy ? SortedBy.toUpperCase() : undefined,
        SortingType: SortingType || undefined,
    };

    return axios.post(urlPurchaseOrders + "/api/PurchaseOrder/GET", {
        pageNumber: page,
        pageSize: PageSize,
        HasPermissionValidation: HasPermissionValidation,
        PurchaseOrderFilters: PurchaseOrderFilters,
    });
}
export function CreatePurchaseOrder(Title, Reference, IdSupplier, Devise, ExpirationDate, PaymentMethod,
    Document, DocumentType, Documents, PurchaseOrderLines
) {
    let formData = new FormData();
    formData.append("purchaseOrder.title", Title);
    formData.append("purchaseOrder.reference", Reference);
    formData.append("purchaseOrder.idSupplier", IdSupplier);
    formData.append("PurchaseOrder.devise", Devise);
    formData.append("purchaseOrder.expirationDate", ExpirationDate);
    formData.append("purchaseOrder.paymentMethod", PaymentMethod);
    formData.append("purchaseOrder.type", DocumentType);
    if (Document) {
        formData.append("purchaseOrder.document", Document);
    }

    if (Documents && Documents.length > 0) {
        for (let i = 0; i < Documents.length; i++) {
            formData.append("purchaseOrder.documents", Documents[i]);
        }
    }

    if (PurchaseOrderLines && PurchaseOrderLines.length > 0) {
        for (let i = 0; i < PurchaseOrderLines.length; i++) {
            let line = PurchaseOrderLines[i];
            formData.append(`purchaseOrder.PurchaseOrderLines[${i}].Title`, line.Title);
            formData.append(`purchaseOrder.PurchaseOrderLines[${i}].Quantity`, line.Quantity);
            formData.append(`purchaseOrder.PurchaseOrderLines[${i}].Threshold`, line.Threshold);
            formData.append(`purchaseOrder.PurchaseOrderLines[${i}].Taxe`, line.Tax);
        }
    }
    return axios.post(urlPurchaseOrders + "/api/PurchaseOrder", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
        },
    });
}

/*              */
export function GeneratePdfDraft(Title, Reference, IdSupplier, Devise, ExpirationDate, PaymentMethod,
    Document, Documents, PurchaseOrderLines
) {
    let formData = new FormData();
    formData.append("PurchaseOrderPdfDraft.title", Title);
    formData.append("PurchaseOrderPdfDraft.reference", Reference);
    formData.append("PurchaseOrderPdfDraft.idSupplier", IdSupplier);
    formData.append("PurchaseOrderPdfDraft.devise", Devise);
    formData.append("PurchaseOrderPdfDraft.expirationDate", ExpirationDate);
    formData.append("PurchaseOrderPdfDraft.paymentMethod", PaymentMethod);

    if (Document) {
        formData.append("PurchaseOrderPdfDraft.document", Document);
    }

    if (Documents && Documents.length > 0) {
        for (let i = 0; i < Documents.length; i++) {
            formData.append("PurchaseOrderPdfDraft.documents", Documents[i]);
        }
    }

    if (PurchaseOrderLines && PurchaseOrderLines.length > 0) {
        for (let i = 0; i < PurchaseOrderLines.length; i++) {
            let line = PurchaseOrderLines[i];
            formData.append(`PurchaseOrderPdfDraft.PurchaseOrderLines[${i}].Title`, line.Title);
            formData.append(`PurchaseOrderPdfDraft.PurchaseOrderLines[${i}].Quantity`, line.Quantity);
            formData.append(`PurchaseOrderPdfDraft.PurchaseOrderLines[${i}].Threshold`, line.Threshold);
            formData.append(`PurchaseOrderPdfDraft.PurchaseOrderLines[${i}].Taxe`, line.Tax);
        }
    }
    return axios.post(urlPurchaseOrders + "/api/PurchaseOrder/GeneratePurchaseOrder",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                Accept: "application/json",
            },
            responseType: "blob",
        }
    );
}

/*              */
export function DownloadPurchaseOrderPdf(purchaseOrderId) {
    return axios.get(urlPurchaseOrders + `/api/PurchaseOrder/${purchaseOrderId}/pdf`,
        {
            responseType: "arraybuffer",
            headers: { "Content-Type": "application/pdf", },
        }
    );
}

export function DeletePurchaseOrder(idPurchaseOrder) {
    return axios.delete(urlPurchaseOrders + "/api/PurchaseOrder/" + idPurchaseOrder);
}

export function EditPurchaseOrder(idPurchaseOrder, editData) {
    let formData = new FormData();
    // Append filesToAdd and filesToDelete
    if (editData.filesToAdd && editData.filesToAdd.length > 0) {
        for (let i = 0; i < editData.filesToAdd.length; i++) {
            formData.append("PurchaseOrder.FilesToAdd", editData.filesToAdd[i]);
        }
    }

    if (editData.filesToDelete && editData.filesToDelete.length > 0) {
        for (let i = 0; i < editData.filesToDelete.length; i++) {
            formData.append("PurchaseOrder.FilesToDelete", editData.filesToDelete[i]);
        }
    }

    // Append PurchaseOrderLines
    if (editData.lines && editData.lines.length > 0) {
        for (let i = 0; i < editData.lines.length; i++) {
            let line = editData.lines[i];
            if (line.idPurchaseOrderline) {
                formData.append(`purchaseOrder.PurchaseOrderLines[${i}].IdPurchaseOrderline`, line.idPurchaseOrderline);
            }
            formData.append(`purchaseOrder.PurchaseOrderLines[${i}].Title`, line.Title);
            formData.append(`purchaseOrder.PurchaseOrderLines[${i}].Quantity`, line.Quantity);
            formData.append(`purchaseOrder.PurchaseOrderLines[${i}].Threshold`, line.Threshold);
            formData.append(`purchaseOrder.PurchaseOrderLines[${i}].Taxe`, line.Tax);
        }
    }
    formData.append("PurchaseOrder.Title", editData.title);
    formData.append("PurchaseOrder.IdSupplier", editData.IdSupplier);
    formData.append("PurchaseOrder.File", editData.file);
    formData.append("PurchaseOrder.IdPurchaseOrder", editData.idPurchaseOrder);
    formData.append("PurchaseOrder.Devise", editData.devise);
    formData.append("PurchaseOrder.Type", editData.type);
    formData.append("PurchaseOrder.Reference", editData.reference);
    formData.append("PurchaseOrder.ExpirationDate", editData.expirationDate);
    formData.append("PurchaseOrder.PaymentMethod", editData.paymentMethod);

    return axios.put(urlPurchaseOrders + "/api/PurchaseOrder/" + idPurchaseOrder,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
    );
}

export function PurchaseOrderIsExistReference(IdPurchaseOrder, Reference) {
    var idquary = !IdPurchaseOrder ? "" : "&IdPurchaseOrder=" + IdPurchaseOrder;
    return axios.get(urlPurchaseOrders + "/api/PurchaseOrder/CheckExistReference?Reference=" + Reference + idquary);
}

export function downloadMultiDocumentPurchaseOrder(fileName) {
    return axios.get(urlPurchaseOrders + "/api/PurchaseOrder/Multifile/" + fileName);
}

export function downloadDocumentPurchaseOrder(fileName) {
    return axios.get(urlPurchaseOrders + "/api/PurchaseOrder/file/" + fileName.replace("Gen.", ""));
}

export function GetCompanyFromPurchaseOrders(BrandName) {
    if (BrandName == null || BrandName == "") {
        return axios.get(urlPurchaseOrders + "/api/Company");
    } else {
        return axios.get(urlPurchaseOrders + "/api/Company?BrandName=" + BrandName);
    }
}

export function ValidatePurchaseOrder(idPurchaseOrder) {
    return axios.put(urlPurchaseOrders + "/api/PurchaseOrder/api/validate/" + idPurchaseOrder);
}

export function RefusePurchaseOrder(idPurchaseOrder, commentaire) {
    return axios.put(urlPurchaseOrders + "/api/PurchaseOrder/api/refuse/" + idPurchaseOrder + "?comment=" + commentaire);
}

export function GetStatusPurchaseOrders() {
    return axios.get(urlPurchaseOrders + "/api/PurchaseOrder/GetStatusFromConfiguration/");
}

/************************ Dashboard APIs *************************/

export function GetInvoiceSummary(startDate, endDate) {
    let apiUrl = urlInvoices + "/api/Dashboard/GETSummary";

    if (startDate && endDate) {
        apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    } else if (startDate) {
        apiUrl += `?startDate=${startDate}`;
    } else if (endDate) {
        apiUrl += `?endDate=${endDate}`;
    }

    return axios.post(apiUrl);
}

export function GetPurchaseOrderSummary(startDate, endDate) {
    let apiUrl = urlPurchaseOrders + "/api/Dashboard/GETSummary";
    if (startDate && endDate) {
        apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    } else if (startDate) {
        apiUrl += `?startDate=${startDate}`;
    } else if (endDate) {
        apiUrl += `?endDate=${endDate}`;
    }
    return axios.post(apiUrl);
}

export function GetPurchaseOrderByThresold(startDate, endDate) {
    let apiUrl =
        urlPurchaseOrders + "/api/Dashboard/GetPurchaseOrdersByThersold";
    if (startDate && endDate) {
        apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    } else if (startDate) {
        apiUrl += `?startDate=${startDate}`;
    } else if (endDate) {
        apiUrl += `?endDate=${endDate}`;
    }
    return axios.post(apiUrl);
}

export function GetTopSuppliers(startDate, endDate) {
    let apiUrl =
        urlPurchaseOrders + "/api/Dashboard/GetPurchaseOrdersBySupplier";
    if (startDate && endDate) {
        apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    } else if (startDate) {
        apiUrl += `?startDate=${startDate}`;
    } else if (endDate) {
        apiUrl += `?endDate=${endDate}`;
    }
    return axios.post(apiUrl);
}

export function GetTopSuppliersByInvoices(startDate, endDate) {
    let apiUrl = urlInvoices + "/api/Dashboard/GetInvoicesBySupplier";

    if (startDate && endDate) {
        apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    } else if (startDate) {
        apiUrl += `?startDate=${startDate}`;
    } else if (endDate) {
        apiUrl += `?endDate=${endDate}`;
    }

    return axios.post(apiUrl);
}

export function GetPaidInvoicesAmountByCurrency(SearchSupplierID, startDate, endDate) {
    let apiUrl = urlInvoices + "/api/Dashboard/GetPaidInvoicesAmountByCurrency";
    if (SearchSupplierID) {
        apiUrl += `?SearchSupplierID=${SearchSupplierID}`;
    }
    if (startDate && endDate) {
        apiUrl += SearchSupplierID ? "&" : "?";
        apiUrl += `StartDate=${startDate}&EndDate=${endDate}`;
    } else if (startDate) {
        apiUrl += SearchSupplierID ? "&" : "?";
        apiUrl += `StartDate=${startDate}`;
    } else if (endDate) {
        apiUrl += SearchSupplierID ? "&" : "?";
        apiUrl += `EndDate=${endDate}`;
    }

    return axios.post(apiUrl);
}

export function GetExpiredPurchaseOrders(startDate, endDate) {
    let apiUrl = urlPurchaseOrders + "/api/Dashboard/GetExpiredPurchaseOrders";
    if (startDate && endDate) {
        apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    } else if (startDate) {
        apiUrl += `?startDate=${startDate}`;
    } else if (endDate) {
        apiUrl += `?endDate=${endDate}`;
    }
    return axios.post(apiUrl);
}

export function GetExpiredInvoices(startDate, endDate) {
    let apiUrl = urlInvoices + "/api/Dashboard/GetExpiredInvoices";
    if (startDate && endDate) {
        apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
    } else if (startDate) {
        apiUrl += `?startDate=${startDate}`;
    } else if (endDate) {
        apiUrl += `?endDate=${endDate}`;
    }

    return axios.post(apiUrl);
}

export function GetCompletedPurchaseOrdersbySuppliers(SearchSupplierID, startDate, endDate) {
    let apiUrl =
        urlPurchaseOrders + "/api/Dashboard/GetCompletedPurchaseOrders";
    if (SearchSupplierID) {
        apiUrl += `?SearchSupplierID=${SearchSupplierID}`;
    }
    if (startDate && endDate) {
        apiUrl += SearchSupplierID ? "&" : "?";
        apiUrl += `StartDate=${startDate}&EndDate=${endDate}`;
    } else if (startDate) {
        apiUrl += SearchSupplierID ? "&" : "?";
        apiUrl += `StartDate=${startDate}`;
    } else if (endDate) {
        apiUrl += SearchSupplierID ? "&" : "?";
        apiUrl += `EndDate=${endDate}`;
    }

    return axios.post(apiUrl);
}

/************************ Invoices APIs *************************/
export function GetAllInvoices(page, PageSize, reference, title, company, supplier, minamount,
    maxamount, deadlinefrom, deadlineto, validationStatus, createdtoDate, createdfromDate, SortedBy, SortingType,
    HasPermissionValidation
) {
    let InvoicesFilters = {
        Reference: reference || undefined,
        Title: title || undefined,
        Company: company || undefined,
        Supplier: supplier || undefined,
        MinAmountTTC: minamount || undefined,
        MaxAmountTTC: maxamount || undefined,
        DeadlineFrom: deadlinefrom || undefined,
        DeadlineTo: deadlineto || undefined,
        ValidationStatus: Array.isArray(validationStatus) && validationStatus.length > 0 ? validationStatus : undefined,
        WithStatus: Array.isArray(validationStatus) && validationStatus.length > 0 ? true : false,
        CreatedTo: createdtoDate || undefined,
        CreatedFrom: createdfromDate || undefined,
        SortedBy: SortedBy ? SortedBy.toUpperCase() : undefined,
        SortingType: SortingType || undefined,
    };

    return axios.post(urlInvoices + "/api/Invoices/GET",
        { pageNumber: page, PageSize, HasPermissionValidation, InvoicesFilters, }
    );
}

export function CreateInvoice(Reference, Title, Devise, Deadline,
    IdCompany, idPurchaseOrder, IdentityDocument, IdentityDocuments, Lines) {
    let formData = new FormData();
    formData.append("reference", Reference);
    formData.append("title", Title);
    formData.append("devise", Devise);
    formData.append("deadline", Deadline);
    formData.append("idCompany", IdCompany);
    formData.append("document", IdentityDocument ? IdentityDocument : null);
    if (IdentityDocuments && IdentityDocuments.length > 0) {
        for (let i = 0; i < IdentityDocuments.length; i++) {
            formData.append("documents", IdentityDocuments[i]);
        }
    }
    if (idPurchaseOrder != null)
        formData.append("idPurchaseOrder", idPurchaseOrder);
    if (Lines.length > 0) {
        const newLines = [];

        Lines.forEach(line => {
            if (line.amountToPay > 0) {
                newLines.push({
                    id: line.id,
                    title: line.title,
                    quantity: line.quantity,
                    unitPrice: line.unitPrice,
                    tax: line.tax,
                    amountToPay: line.amountToPay
                });
            }
        });
        if (newLines.length > 0) {
            formData.append("InvoiceLinesJson", JSON.stringify(newLines));
        }
    }
    return axios.post(urlInvoices + "/api/Invoices", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function DeleteInvoice(idInvoices) {
    return axios.delete(urlInvoices + "/api/Invoices/" + idInvoices);
}

export function fetchFilteredInvoices(startDate, endDate) {
    return axios.post(urlInvoices + "/api/Invoices/GETInvoicesByDates?startDate=" + startDate + "&endDate=" + endDate,
        { startDate, endDate }
    );
}

export function EditInvoice(idInvoices, editData) {
    let formData = new FormData();
    for (let key in editData) {
        let prefixedKey = "Invoice." + key;
        if (key == "filesToAdd") {
            if (editData.filesToAdd && editData.filesToAdd.length > 0) {
                for (let i = 0; i < editData.filesToAdd.length; i++) {
                    formData.append(
                        "Invoice.FilesToAdd",
                        editData.filesToAdd[i]
                    );
                }
            }
        } else if (key == "filesToDelete") {
            if (editData.filesToDelete && editData.filesToDelete.length > 0) {
                for (let i = 0; i < editData.filesToDelete.length; i++) {
                    formData.append(
                        "Invoice.FilesToDelete",
                        editData.filesToDelete[i]
                    );
                }
            }
        } else if (key == "invoiceLines") {
            if (editData.invoiceLines.length > 0) {
                const newLines = [];

                editData.invoiceLines.forEach(line => {
                    newLines.push({
                        id: line.invoiceItemId,
                        amountToPay: line.amountPaid
                    });
                });
                if (newLines.length > 0) {
                    formData.append("Invoice.InvoiceLinesJson", JSON.stringify(newLines));
                }
            }
        }
        else if (['amount', 'tax', 'devise', 'idPurchaseOrder'].includes(key)) {
            continue;
        } else {
            formData.append(prefixedKey, editData[key]);
        }
    }
    return axios.put(urlInvoices + "/api/Invoices/" + idInvoices, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
}

export function InvoiceIsExistReference(IdInvoice, Reference) {
    var idquary = !IdInvoice ? "" : "&IdInvoice=" + IdInvoice;
    return axios.get(urlInvoices + "/api/Invoices/CheckExistReference?Reference=" + Reference + idquary);
}

export function downloadMultiDocumentInvoices(fileName) {
    return axios.get(urlInvoices + "/api/Invoices/Multifile/" + fileName);
}

export function downloadDocumentInvoices(fileName) {
    return axios.get(urlInvoices + "/api/Invoices/file/" + fileName);
}

export function GetCompanyFromInvoices(BrandName) {
    if (BrandName == null || BrandName == "") {
        return axios.get(urlInvoices + "/api/Company");
    } else {
        return axios.get(urlInvoices + "/api/Company?BrandName=" + BrandName);
    }
}

export function GetSupplierFromInvoices(BrandName) {
    if (BrandName == null || BrandName == "") {
        return axios.get(urlInvoices + "/api/Supplier");
    } else {
        return axios.get(urlInvoices + "/api/Supplier?BrandName=" + BrandName);
    }
}

export function PaidInvoices(idInvoices) {
    return axios.put(urlInvoices + "/api/Invoices/api/paid/" + idInvoices);
}

export function RefuseInvoices(idInvoices, commentaire) {
    return axios.put(urlInvoices + "/api/Invoices/api/refuse/" + idInvoices + "?comment=" + commentaire);
}

export function ValideInvoices(idInvoices) {
    return axios.put(urlInvoices + "/api/Invoices/api/valide/" + idInvoices);
}

export function GetPurchaseOrderFromInvoices(Title, SupplierId) {
    const queryParams = {
        ...(Title && { Title: Title }),
        ...(SupplierId && { SupplierID: SupplierId }),
    };
    return axios.get(urlInvoices + "/api/PurchaseOrder", { params: queryParams, });
}

export function GetStatusInvoices() {
    return axios.get(urlInvoices + "/api/Invoices/GetStatusFromConfiguration/");
}

export function GetDeviseFromPurchaseOrder(idPurchaseOrder) {
    return axios.get(urlPurchaseOrders + "/api/PurchaseOrder/" + idPurchaseOrder + "/Devise");
}

export function CanValideFactureByPurchaseOrder(idPurchaseOrder, factureAmout) {
    return axios.get(urlPurchaseOrders + "/api/PurchaseOrder/" + idPurchaseOrder + "/CanValideFacture/" + factureAmout);
}

export function ExportInvoicesToExcel(reference, title, company, supplier, minamount, maxamount, deadlinefrom,
    deadlineto, validationStatus, createdtoDate, createdfromDate, SortedBy, SortingType) {
    let InvoicesFilters = {
        Reference: reference || undefined,
        Title: title || undefined,
        Company: company || undefined,
        Supplier: supplier || undefined,
        MinAmountTTC: minamount || undefined,
        MaxAmountTTC: maxamount || undefined,
        DeadlineFrom: deadlinefrom || undefined,
        DeadlineTo: deadlineto || undefined,
        ValidationStatus: Array.isArray(validationStatus) && validationStatus.length > 0 ? validationStatus : undefined,
        WithStatus: Array.isArray(validationStatus) && validationStatus.length > 0 ? true : false,
        CreatedTo: createdtoDate || undefined,
        CreatedFrom: createdfromDate || undefined,
        SortedBy: SortedBy ? SortedBy.toUpperCase() : undefined,
        SortingType: SortingType || undefined,
    };
    return axios.post(urlInvoices + "/api/Invoices/ExportXsl", { InvoicesFilters, },
        { responseType: "blob" }
    );
}

/************************ Menu APIs *************************/

export function GetMenuById(id) {
    return axios.get(urlSecurity + "/v1/Menu/" + id);
}

/************************ Role APIs *************************/

export function addRole(Roleinfo) {
    return axios.post(urlSecurity + "/v1/SecurityGroup/", Roleinfo);
}

export function deleteRole(idRole) {
    return axios.delete(urlSecurity + "/v1/SecurityGroup/" + idRole);
}

export function getRoleByName(RoleName) {
    return axios.get(urlSecurity + "/v1/SecurityGroup/name/" + RoleName);
}

export function GetAllSecurityGroup(pageNumber, pageSize, SecurityGroupFilters, SortedBy, SortingType) {
    SecurityGroupFilters.SortedBy = SortedBy.toUpperCase();
    SecurityGroupFilters.SortingType = SortingType;
    return axios.post(urlSecurity + "/v1/SecurityGroup/ByOrganisationID?pageNumber=" + pageNumber + "&pageSize=" + pageSize,
        SecurityGroupFilters
    );
}

export function GetOptimaApplication() {
    return axios.get(urlSecurity + "/v1/Application/name/optima");
}

export function GetApplicationModule(id) {
    return axios.get(urlSecurity + "/v1/Application/ApplicationModule/" + id);
}

export function addMultiPermissions(RoleId, PermissionsIds) {
    var MultiPermissionsData = {
        securityGroupId: RoleId,
        featureId: PermissionsIds,
    };
    return axios.post(urlSecurity + "/v1/SecurityGroup/MultiSecurityGroupFeatures/", MultiPermissionsData);
}

export function updateMultiPermissions(RoleId, PermissionsIdstoAdd, PermissionsIdstoDelete) {
    var MultiPermissionsData = {
        securityGroupId: RoleId,
        featureIdToAdd: PermissionsIdstoAdd,
        featureIdToDelete: PermissionsIdstoDelete,
    };
    return axios.put(urlSecurity + "/v1/SecurityGroup/UpdateMultiSecurityGroupFeatures/", MultiPermissionsData);
}

export function addMultiUsers(RoleId, UsersIds) {
    var MultiUsersData = {
        securityGroupId: RoleId,
        usersId: UsersIds,
    };
    return axios.post(urlSecurity + "/v1/SecurityGroup/MultiSecurityGroupUsers/", MultiUsersData);
}

export function updateMultiUsers(RoleId, UsersIdstoAdd, UsersIdstoDelete) {
    var MultiUsersData = {
        securityGroupId: RoleId,
        usersIdToAdd: UsersIdstoAdd,
        usersIdToDelete: UsersIdstoDelete,
    };
    return axios.put(urlSecurity + "/v1/SecurityGroup/UpdateMultiSecurityGroupUsers/", MultiUsersData);
}

export function getRoleById(RoleId) {
    return axios.get(urlSecurity + "/v1/SecurityGroup/" + RoleId);
}

export function UpdateRole(Roleinfo) {
    return axios.put(urlSecurity + "/v1/SecurityGroup/" + Roleinfo.id, Roleinfo);
}

export function GetOrganisationParentDefaultRoles() {
    return axios.get(urlSecurity + "/v1/SecurityGroup/OrganisationParentRoles");
}

export function ResetRole(RoleId) {
    return axios.put(urlSecurity + "/v1/SecurityGroup/ResetSecurityGroupFeatures?idsecuritygroup=" + RoleId);
}

export function GetUsersByOrganisationId(name, id) {
    return axios.post(urlSecurity + "/v1/User/GetUsers?name=" + name, { id });
}

export function CheckPermissionByUser(feature) {
    return axios.get(urlSecurity + "/v1/SecurityGroup/CheckFeatureByUser?feature=" + feature);
}

export function GetStatusSecurityGroup() {
    return axios.get(urlSecurity + "/v1/SecurityGroup/GetStatusFromConfiguration/");
}

/************************ Products APIs *************************/

export function getProducts(page, pageSize, Filters, sortedBy, sortingType) {
    const params = {};
    params.PageNumber = page;
    params.PageSize = pageSize;

    if (sortedBy) params.SortBy = sortedBy.toUpperCase();
    if (sortingType == "DESC") params.SortDescending = true;
    else if (sortingType == "ASC") params.SortDescending = false;

    if (Filters) {
        if (Filters.SearchNom) params.SearchNom = Filters.SearchNom;
        if (Filters.CategoryName) params.CategoryName = Filters.CategoryName;
        if (Filters.SearchMarque) params.SearchMarque = Filters.SearchMarque;
        if (Filters.isActive) params.isActive = Filters.isActive;
        if (Filters.availability == true) params.Availability = true
        else if (Filters.availability == false) params.Availability = false;
        if (Filters.CreationDate) params.CreationDate = Filters.CreationDate;
        if (Filters.minPrice) params.Min = Filters.minPrice;
        if (Filters.maxPrice) params.Max = Filters.maxPrice;
        if (Filters.searchTerm) params.searchTerm = Filters.searchTerm;
    }

    return axios.get(urlProducts + "/api/Product", { params });
}

export function saveProduct(form) {
    return axios.post(urlProducts + "/api/Product", form,)
}

export function ChangeStatusOfProductById(id) {
    return axios.put(`${urlProducts}/api/Product/ChangeStatus/${id}`);
}

export function getCategoriesProduct() {
    return axios.post(urlProducts + "/api/Category/GET")
}

export function getAllBrands() {
    return axios.get(`${urlProducts}/api/Brand/GetAllBrands`)
}

/************************ Customer APIs *************************/

export function getCustomers(pageNumber, pageSize, UserName, TypeActivity, Address, NomSocial, status, createdDateFrom, createdDateTo, sortedBy, sortingType, search) {
    const CustomersFilters = {};
    if (UserName !== null) CustomersFilters.FullName = UserName;
    if (TypeActivity !== null) CustomersFilters.TypeActivity = TypeActivity;
    if (Address !== null) CustomersFilters.Address = Address;
    if (NomSocial !== null) CustomersFilters.NomSocial = NomSocial;
    if (status !== null && status !== false && status.length > 0) {
        CustomersFilters.Status = status;
    }
    if (createdDateFrom !== null) CustomersFilters.CreatedFrom = createdDateFrom;
    if (createdDateTo !== null) CustomersFilters.CreatedTo = createdDateTo;
    if (sortedBy !== null) CustomersFilters.SortedBy = sortedBy.toUpperCase();
    if (sortingType !== null) CustomersFilters.SortingType = sortingType;
    if (search !== null) CustomersFilters.searchTerm = search;

    return axios.post(urlCustomers + "/api/Customers/GET",
        { pageNumber, pageSize, CustomersFilters }
    );
}

export function getClientsById(clientId) {
    return axios.get(`${urlCustomers}/api/Customers/${clientId}`);
}

export function ChangeStatusOfCustomerByid(clientId, statusValue, comment = "") {
    return axios.put(`${urlCustomers}/api/CustomersAdmin/api/validate/${clientId}/${statusValue}`, null,
        { params: { comment: comment } }
    );
}

export function UpdateClientDeleteStatus(clientId, client) {
    return axios.put(`${urlCustomers}/api/Customers/${clientId}`, client,
        { headers: { "Content-Type": "multipart/form-data", } }
    );
}

export function GetTraceValidationListByClientId(clientId) {
    return axios.get(`${urlCustomers}/api/CustomersAdmin/GetTraceValidationList/${clientId}`);

}


/************************ Orders APIs *************************/

export function getOrders(page, pageSize, sortedBy, sortingType, status, creationDate,
    orderNumber, clientName, totalAmount, totalQuantity, collectionTime, type) {
    const params = {};

    if (page !== null && page !== undefined) params.PageNumber = page;
    if (pageSize !== null && pageSize !== undefined) params.PageSize = pageSize;
    if (sortedBy !== null && sortedBy !== undefined) params.SortBy = sortedBy;
    if (sortingType !== null && sortingType !== undefined) params.SortDescending = sortingType === 'DESC';
    if (status !== null && status !== undefined) params.Status = status;
    if (creationDate !== null && creationDate !== undefined) params.CreationDate = creationDate;
    if (orderNumber !== null && orderNumber !== undefined) params.OrderNumber = orderNumber;
    if (clientName !== null && clientName !== undefined) params.ClientName = clientName;
    if (totalAmount !== null && totalAmount !== undefined) params.TotalAmount = totalAmount;
    if (totalQuantity !== null && totalQuantity !== undefined) params.TotalQuantity = totalQuantity;
    if (collectionTime !== null && collectionTime !== undefined) params.CollectionTime = collectionTime.dateTimeUtc;
    if (type !== null && type !== undefined) params.InstantOrder = type == 0 ? false : true;
    return axios.get(urlProducts + "/api/Commands/All", { params });
}

export function getOrderById(id) {
    return axios.get(urlProducts + `/api/Commands/${id}`);
}

export function getOrderValidationTrace(orderId) {
    return axios.get(urlProducts + `/api/Commands/OrderValidationTrace/${orderId}`);
}

export function updateOrderStatus(orderId, newStatus, comment) {
    return axios.put(`${urlProducts}/api/Commands/${orderId}`, null,
        { params: { newStatus, comment } }
    );
}

/************************ Categories APIs *************************/

export function AddCategory(categoryData) {
    const data = new FormData();
    data.append("name", categoryData.name);
    data.append("description", categoryData.description);
    data.append("parent_category_id", categoryData.parent_category_id);
    if (categoryData.LogoImage) { data.append("LogoImage", categoryData.LogoImage); }

    return axios.post(urlProducts + "/api/Category", data,
        { headers: { "Content-Type": "multipart/form-data", } }
    );
}

export function getCategory(params = {}) {
    const queryParams = new URLSearchParams({
        PageIndex: params.PageIndex || '',
        PageSize: params.PageSize || '',
        CategoryName: params.CategoryName || '',
        CategoryDescription: params.CategoryDescription || '',
        IsActive: params.IsActive || '',
        Created: params.Created || ''
    }).toString();

    return axios.get(`${urlProducts}/api/Category?${queryParams}`);
}

export function UpdateCategoryStatus(category) {
    return axios.put(urlProducts + "/api/Category/Status", category,
        { headers: { "Content-Type": "application/json" } }
    );
}

export function deleteCategoryById(categoryId) {
    return axios.delete(urlProducts + "/api/Category",
        { params: { categoryId } }
    );
}

export function getSubCategoriesById(categoryId) {
    return axios.get(urlProducts + `/api/Category/subCategories/${categoryId}`)
}

export function updateCategory(category) {
    const data = new FormData();
    data.append("CategoryId", category.CategoryId);
    data.append("name", category.name);
    data.append("description", category.description);
    data.append("parent_category_id", category.parent_category_id);
    data.append("LogoImage", category.LogoImage)

    return axios.put(urlProducts + "/api/Category", data,
        { headers: { "Content-Type": "multipart/form-data", }, }
    );
}

export function getProductById(productId) {
    return axios.get(urlProducts + `/api/Product/${productId}`)
}

export function UpdateProductCatalog(productId, form) {
    return axios.put(urlProducts + `/api/Product/${productId}`, form)
}

export function getPriceListProduct(idProduct, DiscountType, PageNumber, PageSize) {
    return axios.get(urlProducts + "/api/PriceLists/product/" + idProduct, {
        params: { PageNumber, PageSize, DiscountType, },
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
    });
}

export function savePriceListProduct(form) {
    return axios.post(urlProducts + "/api/PriceLists", form)
}

export function getProductsWithVariants() {
    return axios.get(urlProducts + "/api/Product/with-variants")
}

export function getPriceListItems(priceListId) {
    return axios.get(urlProducts + `/api/PriceLists/${priceListId}`)
}

export function saveProductPriceListItem(id, form) {
    return axios.post(urlProducts + `/api/PriceLists/${id}/items`, form)
}

export function getAllSuppliersForProducts() {
    return axios.get(`${urlSuppliers}/api/SupplierV2/GetAllSuppliers`);
}
export function getAllCategories() {
    return axios.get(urlProducts + "/api/Category/GetAllCategories")
}

export function GetMaxPrice() {
    return axios.get(`${urlProducts}/api/Product/GetMaxPrice`);
}
export function ToValidateProduct(idProduct) {
    return axios.put(`${urlProducts}/api/Product/ToValidateProduct/${idProduct}`);
}

export function RejectProduct(idProduct, commentaire) {
    const formData = new FormData();
    formData.append('comment', commentaire);
    return axios.put(`${urlProducts}/api/Product/RejectProduct/${idProduct}`, formData);
}

export function RectifyProduct(idProduct, commentaire) {
    const formData = new FormData();
    formData.append('comment', commentaire);
    return axios.put(`${urlProducts}/api/Product/RectificationProduct/${idProduct}`, formData);
}

export function ValidateProduct(idProduct) {
    return axios.put(`${urlProducts}/api/Product/ValidatedProduct/${idProduct}`);
}
export function PublishProduct(idProduct) {
    return axios.put(`${urlProducts}/api/Product/PublishProduct/${idProduct}`);
}

export function GetProductValidationTrace(idProduct) {
    return axios.get(`${urlProducts}/api/Product/ProductValidationTrace/${idProduct}`);
}

export function GetProductStatus(idProduct) {
    return axios.get(`${urlProducts}/api/Product/GetProductStatus/${idProduct}`);
}

// Brand Apis 
export function CreateBrand(brandName, Description, logoFile, categories, SupplierId, SupplierName) {
    let Data = new FormData()
    Data.append("BrandName", brandName);
    Data.append("Description", Description);
    Data.append("SupplierId", SupplierId);
    Data.append("SupplierName", SupplierName);
    Data.append("Logo", logoFile);
    categories.forEach((category, index) => {
        Data.append(`Categories[${index}]`, category);
    });
    return axios.post(urlProducts + `/api/Brand`, Data,
        { headers: { "Content-Type": "multipart/form-data", }, }
    )
}

export function getBrands(page, pageSize, BrandName, CategoryId, SupplierId,
    CreatedFrom, CreatedTo, sortedBy, sortingType) {
    const params = new URLSearchParams();
    params.append("pageNumber", page);
    params.append("pageSize", pageSize);
    if (BrandName !== null) params.append("brandName", BrandName);
    if (CategoryId.length !== 0) params.append("CategoryId", CategoryId);
    if (SupplierId !== null) params.append("SupplierId", SupplierId);
    if (CreatedFrom !== null) params.append("CreatedFrom", CreatedFrom);
    if (CreatedTo !== null) params.append("CreatedTo", CreatedTo);
    if (sortedBy !== null) params.append("sortedBy", sortedBy.toUpperCase());
    if (sortingType !== null) params.append("sortingType", sortingType);

    return axios.get(`${urlProducts}/api/Brand`, { params });
}

export function getProductTypes(page, pageSize, ProductTypeName, productTypeCategory,
    Created, sortBy, SortDescending, SearchTerm) {
    const params = new URLSearchParams();
    params.append("pageNumber", page);
    params.append("pageSize", pageSize);
    if (ProductTypeName !== null) params.append("SearchName", ProductTypeName.replaceAll(' ', '').toUpperCase());
    if (SearchTerm !== null) params.append("SearchTerm", SearchTerm);
    //if (CreatedFrom !== null) params.append("CreatedFrom", CreatedFrom);
    //if (CreatedTo !== null) params.append("CreatedTo", CreatedTo);
    if (productTypeCategory != null) params.append("productTypeCategory", productTypeCategory);
    if (Created != null) params.append("Created", Created);
    if (sortBy !== null) params.append("sortBy", sortBy.toUpperCase());
    if (SortDescending !== null) params.append("SortDescending", SortDescending == "DESC" ? true : false);

    return axios.get(`${urlDelivries}/api/ProductCarryingType`, { params });
}

export function getAllProductTypes() {
    return axios.get(`${urlDelivries}/api/ProductCarryingType/All`);
}

export function CreateProductType(ProductTypeName, selectedCategory) {
    let Data = new FormData();
    Data.append("name", ProductTypeName);
    Data.append("TypeCategory", selectedCategory);
    return axios.post(urlDelivries + `/api/ProductCarryingType`, Data, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

export function UpdateProductType(ProductTypeId, ProductTypeName, TypeCategory) {
    let Data = new FormData();
    Data.append("Id", ProductTypeId);
    Data.append("name", ProductTypeName);
    Data.append("TypeCategory", TypeCategory);
    return axios.put(urlDelivries + `/api/ProductCarryingType`, Data,
        { headers: { "Content-Type": "multipart/form-data", }, }
    );
}

export function DeleteProductType(ProductTypeId) {
    return axios.delete(`${urlDelivries}/api/ProductCarryingType/${ProductTypeId}`);
}

export function UpdateBrand(brandId, brandName, Description, logoFile, categories, SupplierId, SupplierName) {
    let Data = new FormData();
    Data.append("BrandId", brandId);
    Data.append("BrandName", brandName);
    Data.append("Description", Description);
    Data.append("SupplierId", SupplierId);
    Data.append("SupplierName", SupplierName);
    Data.append("Logo", logoFile);
    categories.forEach((category, index) => {
        Data.append(`Categories[${index}]`, category);
    });

    return axios.put(urlProducts + `/api/Brand/UpdateBrandById`, Data,
        { headers: { "Content-Type": "multipart/form-data", }, }
    );
}

export function DeleteBrand(idBrand) {
    return axios.delete(urlProducts + `/api/Brand/`,
        { params: { brandId: idBrand, }, }
    );
}

export function GetUpComingDates(ProductId, PriceListId, discountType) {
    return axios.get(urlProducts + `/api/PriceLists/UpcomingDates/` + ProductId, {
        params: {
            PriceListId: PriceListId,
            DiscountType: discountType,
        },
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
    });
}

export function getOrderPdf(orderId) {
    return axios.get(urlProducts + `/api/Commands/orderPdf/${orderId}`, {
        responseType: 'blob',
    });
}

export function GetInvoicePdf(invoiceId) {
    return axios.get(urlInvoices + `/api/Invoices/${invoiceId}/pdf`, {
        responseType: "blob"
    });
}

export function generatePurchaseOrderPdf(idPurchaseOrder) {
    return axios.post(urlPurchaseOrders + `/api/PurchaseOrder/GeneratePurchaseOrder/${idPurchaseOrder}`, {}, {
        responseType: 'blob',
    });
}

export function getPurchaseOrderById(idPurchaseOrder) {
    return axios.get(urlPurchaseOrders + `/api/PurchaseOrder/${idPurchaseOrder}`, {
    });
}

export const getDeliveries = (pageNumber, pageSize, filters) => {
    return axios.post(urlDelivries + `/api/Deliveries/Get`, {
        PageNumber: pageNumber,
        PageSize: pageSize,
        ...filters,
    });
};

export const deactivateCompanyAccount = async (CompanyId, Status) => {
    const response = await axios.put(urlDelivries + `/api/Company/DeactivateAccount`, null,
        { params: { CompanyId, Status, }, }
    );
    return response.data;
};

export function getCompanies(pageNumber, pageSize, filters = {}) {
    const params = new URLSearchParams();

    params.append("PageNumber", pageNumber);
    params.append("PageSize", pageSize);
    if (filters.SortedBy) params.append("SortBy", filters.SortedBy);
    if (filters.SortingType !== null) params.append("SortDescending", filters.SortingType == "DESC" ? true : false);
    if (filters.SearchTerm) params.append("SearchTerm", filters.SearchTerm);
    if (filters.SearchName) params.append("SearchName", filters.SearchName);
    if (filters.SearchEmail) params.append("SearchEmail", filters.SearchEmail);
    if (filters.SearchPhone) params.append("SearchPhone", filters.SearchPhone);
    if (filters.SearchAddress) params.append("SearchAddress", filters.SearchAddress);
    if (filters.SearchTaxIdentificationNumber) params.append("SearchTaxIdentificationNumber", filters.SearchTaxIdentificationNumber);
    if (filters.IsActive !== null) {
        params.append("IsActive", filters.IsActive);
    }
    if (filters.CreationDate) params.append("CreationDate", filters.CreationDate);
    return axios.get(`${urlDelivries}/api/Company/GetCompanies`, { params });
}

export function getDeliveryPersonsByCompanyId(companyId, parameters, filters = {}) {
    const params = new URLSearchParams();
    params.append("PageNumber", parameters.PageNumber);
    params.append("PageSize", parameters.PageSize);

    if (filters.SortBy) params.append("SortBy", filters.SortBy);
    if (filters.SortDescending !== undefined) params.append("SortDescending", filters.SortDescending);
    if (filters.SearchDeliveryPersonId) params.append("SearchDeliveryPersonId", filters.SearchDeliveryPersonId);
    if (filters.SearchFullName) params.append("SearchFullName", filters.SearchFullName);
    if (filters.SearchPhone) params.append("SearchPhone", filters.SearchPhone);
    if (filters.SearchMail) params.append("SearchMail", filters.SearchMail);
    if (filters.SearchIsActive !== undefined && filters.SearchIsActive !== null) {
        params.append("SearchIsActive", filters.SearchIsActive);
    }
    if (filters.CreationDate) params.append("CreationDate", filters.CreationDate);

    return axios.get(`${urlDelivries}/api/DeliveriesPerson/DeliveryPersonsByCompanyId/${companyId}`, {
        params,
    });
}

export function getDeliveryCompanyInformation(companyId) {
    return axios.get(`${urlDelivries}/api/Company/DeliveryCompanyInformation/${companyId}`);
}

export function createDeliveryCompany(formData) {
    return axios.post(`${urlDelivries}/api/Company/CreateCompany`, formData,
        { headers: { 'Content-Type': 'multipart/form-data', }, }
    );
}

export const getAutoMobiles = (companyId, params = {}) => {
    return axios.get(`${urlDelivries}/api/AutoMobile/GetAutoMobiles/${companyId}`, {
        params: {
            PageNumber: params.PageNumber || 1,
            PageSize: params.PageSize || 10,
            SortBy: params.SortBy || 'licensePlate',
            SortDescending: params.SortDescending || false,
            SearchTerm: params.SearchTerm || '',
            Brand: params.Brand || '',
            Model: params.Model || '',
            LicensePlate: params.LicensePlate || '',
            MaximumLoad: params.MaximumLoad || '',
            Created: params.Created || ''
        }
    });
};

export function getAllAutoMobiles(companyId) {
    return axios.get(`${urlDelivries}/api/AutoMobile/GetAllAutoMobiles/${companyId}`);
}

export function createAutoMobile(autoMobileData) {
    return axios.post(`${urlDelivries}/api/AutoMobile/CreateAutoMobile`, autoMobileData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );
}

export function addDeliveryPerson(formData) {
    return axios.post(`${urlDelivries}/api/DeliveriesPerson/AddDeliveryPerson`, formData,
        { headers: { 'Content-Type': 'multipart/form-data', }, }
    );
}

export function getDeliveryOrders(params) {
    return axios.get(`${urlDelivries}/api/Deliveries/GetDeliveryOrders`, { params });
}

export function getinitializedDeliveryOrders(params) {
    return axios.get(`${urlDelivries}/api/Deliveries/GetClientOrders`, { params });
}

export function getDeliveryOrdersByCompanyId(companyId, params) {
    return axios.get(`${urlDelivries}/api/Deliveries/GetDeliveryOrders/${companyId}`, { params });
}


export function updateDeliveryCompanyInformation(companyId, formData) {
    return axios.put(`${urlDelivries}/api/Company/UpdateDeliveryCompanyInformation/${companyId}`, formData,
        { headers: { 'Content-Type': 'multipart/form-data', }, }
    );
}


export function updatePurchaseOrderItemStatus(data) {
    return axios.post(urlPurchaseOrders + `/api/PurchaseOrderItem/updateItemStatus`, data,
        { headers: { 'Content-Type': 'multipart/form-data', }, }
    );
}

export function getClientOrdersByOrderId(orderId, params) {
    return axios.get(`${urlDelivries}/api/Deliveries/GetClientOrdersByOrderId/${orderId}`,
        { params, }
    );
}

export function getClientOrderDetailsById(deliveryItemId) {
    return axios.get(`${urlDelivries}/api/Deliveries/GetClientOrdersDetailsById/${deliveryItemId}`);
}

export function getDeliveryCompaniesByProductCarryingTypeId(Id) {
    return axios.get(`${urlDelivries}/api/Company/DeliveryCompaniesByProductCarryingType/${Id}`);
}

export function getDeliveryCompanies() {
    return axios.get(`${urlDelivries}/api/Company/DeliveryCompanies`);
}

export function CreateDeliveryOrder(ClientOrdersIds, Title, PickupPointLocationId, DeliveryCompanyId) {
    const formData = new FormData();
    ClientOrdersIds.forEach(id => formData.append("ClientOrdersIds", id));

    formData.append("Title", Title);
    if (PickupPointLocationId !== undefined) formData.append("PickupPointLocationId", PickupPointLocationId);
    formData.append("DeliveryCompanyId", DeliveryCompanyId);

    return axios.post(
        `${urlDelivries}/api/Deliveries/CreateDeliveryOrder`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );
}

export function setDeliveryOrderForCompany(CompanyId, DeliveryOrderId, IdPickupPointLocation) {
    return axios.post(`${urlDelivries}/api/Company/setForCompany`, null,
        { params: { CompanyId, DeliveryOrderId, IdPickupPointLocation }, }
    );
}

export function getDeliveryPersonInfoById(deliveryPersonId) {
    return axios.get(`${urlDelivries}/api/DeliveriesPerson/DeliveryPersonInformationById/${deliveryPersonId}`);
}

export function DeliveryAcceptance(DeliveryOrderId, IsAccepted) {
    return axios.put(
        `${urlDelivries}/api/Company/CompanyDeliveryAcceptance/${DeliveryOrderId}/${IsAccepted}`
    );
}
export function GetAllDeliveryPersonsForDeliveryCompany() {
    return axios.get(`${urlDelivries}/api/DeliveriesPerson/GetAllDeliveryPersons`);
}
export function setDeliveryToPerson(DeliveryPersonId, ClientOrderId) {
    return axios.post(
        `${urlDelivries}/api/DeliveriesPerson/setDeliveryPerson/${DeliveryPersonId}/${ClientOrderId}`
    );
}

export function AssignDeliveryOrderToPerson(deliveryPersonId, deliveryOrderId) {
    return axios.post(
        `${urlDelivries}/api/DeliveriesPerson/AssignDeliveryOrderToPerson/${deliveryPersonId}/${deliveryOrderId}`
    );
}


export function updateDeliveryPersonInfo(deliveryPersonId, formData) {
    return axios.put(`${urlDelivries}/api/DeliveriesPerson/UpdateDeliveryPersonInformation/${deliveryPersonId}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}


export const updateAutoMobile = (vehicleId, formData) => {
    return axios.put(`${urlDelivries}/api/AutoMobile/UpdateAutoMobile/${vehicleId}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

// --------------------------------------------------------------------------------------------------

export function getMasterOrders(page, pageSize, sortedBy, sortingType, search, productName, quantity, status, unitPrice, totalPrice, startDate, endDate) {

    const params = new URLSearchParams();
    if (page !== null && page !== undefined) params.append("PageNumber", page);
    if (pageSize !== null && pageSize !== undefined) params.append("PageSize", pageSize);
    if (sortedBy !== null && sortedBy !== undefined) params.append("SortBy", sortedBy);
    if (sortingType !== null && sortingType !== undefined) params.append("SortDescending", sortingType == "DESC" ? true : false);
    if (search !== null && search !== undefined) params.append("SearchTerm", search);
    if (productName !== null && productName !== undefined) params.append("Name", productName);
    if (quantity !== null && quantity !== undefined) params.append("Quantity", quantity);
    if (status !== null && status !== undefined) params.append("Status", status);
    if (unitPrice !== null && unitPrice !== undefined) params.append("unitPrice", unitPrice);
    if (totalPrice !== null && totalPrice !== undefined) params.append("totalPrice", totalPrice);
    if (startDate !== null && startDate !== undefined) params.append("startDateTime", startDate);
    if (endDate !== null && endDate !== undefined) params.append("endDateTime", endDate.dateTimeUtc);

    return axios.get(`${urlProducts}/api/MasterOrder`, { params });
}

export function EnforcePO(masterOrderId) {
    return axios.put(`${urlProducts}/api/MasterOrder/EnforcePO/${masterOrderId}`);
}

export function getMasterOrderById(masterOrderId, PageNumber, PageSize, sortedBy, sortingType, search, status, CreationDate, OrderNumber, ClientName, TotalAmount, TotalQuantity) {
    const params = new URLSearchParams();
    if (PageNumber !== null && PageNumber !== undefined) params.append("PageNumber", PageNumber);
    if (PageSize !== null && PageSize !== undefined) params.append("PageSize", PageSize);
    if (sortedBy !== null && sortedBy !== undefined) params.append("SortBy", sortedBy);
    if (sortingType !== null && sortingType !== undefined) params.append("SortDescending", sortingType == "DESC" ? true : false);
    if (CreationDate !== null && CreationDate !== undefined) params.append("CreationDate", CreationDate);
    if (OrderNumber !== null && OrderNumber !== undefined) params.append("OrderNumber", OrderNumber);
    if (ClientName !== null && ClientName !== undefined) params.append("ClientName", ClientName);
    if (TotalAmount !== null && TotalAmount !== undefined) params.append("TotalAmount", TotalAmount);
    if (TotalQuantity !== null && TotalQuantity !== undefined) params.append("TotalQuantity", TotalQuantity);
    if (status !== null && status !== undefined) params.append("Status", status);
    if (search !== null && search !== undefined) params.append("SearchTerm", search);
    return axios.get(`${urlProducts}/api/MasterOrder/GetClientsOrdersByMasterOrderId/${masterOrderId}`, { params });
}

export function updateUserToken(token) {
    return axios.put(`${urlNotifications}/api/EmailNotification/updateBackOfficeUserToken`,
        token,
        { headers: { "Content-Type": "application/json" } }
    );
}

export function getBackOfficeNotification(PageNumber, PageSize, search, CreationDate) {
    const params = new URLSearchParams();
    if (PageNumber !== null && PageNumber !== undefined) params.append("PageNumber", PageNumber);
    if (PageSize !== null && PageSize !== undefined) params.append("PageSize", PageSize);
    if (search !== null && search !== undefined) params.append("SearchTerm", search);
    if (CreationDate !== null && CreationDate !== undefined) params.append("Created", CreationDate);
    return axios.get(`${urlNotifications}/api/EmailNotification/GetBackOfficeNotification/`, { params });
}

export function ProductIsOrdered(productId) {
    return axios.get(urlProducts + `/api/Product/ProductIsOrdered/${productId}`);
}

export function setNotificationAsRead(ids) {
    return axios.put(`${urlNotifications}/api/EmailNotification/updateReadStatus`, ids);
}

export function getAllSupplierLocations() {
    return axios.get(`${urlSuppliers}/api/Locations/GetAllLocations`)
}

export function getPurchaseOrderItemsForInvoice(Id) {
    return axios.get(`${urlPurchaseOrders}/api/PurchaseOrderItem/PurchaseOrderItems/${Id}`);
}


// ------------------- Pickup Point ------------------------------

export function GetPickupPointLocation(idLocation) {
    return axios.get(urlDelivries + `/api/PickupPointLocation/${idLocation}`);
}

export function getPickupPointLocationlist(page, PageSize,
    LocationName, Address, City, PostalCode, Country, SortedBy, SortingType) {

    let PickupPointLocationFilters = {};
    LocationName !== null ? (PickupPointLocationFilters.LocationName = LocationName) : delete PickupPointLocationFilters.LocationName;
    Address !== null ? (PickupPointLocationFilters.Address = Address) : delete PickupPointLocationFilters.Address;
    City !== null ? (PickupPointLocationFilters.City = City) : delete PickupPointLocationFilters.City;
    PostalCode !== null ? (PickupPointLocationFilters.PostalCode = PostalCode) : delete PickupPointLocationFilters.PostalCode;
    Country !== null ? (PickupPointLocationFilters.Country = Country) : delete PickupPointLocationFilters.Country;
    SortedBy !== null ? (PickupPointLocationFilters.SortedBy = SortedBy.toUpperCase()) : delete PickupPointLocationFilters.SortedBy;
    SortingType !== null ? (PickupPointLocationFilters.SortingType = SortingType) : delete PickupPointLocationFilters.SortingType;

    return axios.post(urlDelivries + "/api/PickupPointLocation/GET?PageNumber=" + page + "&PageSize=" + PageSize,
        PickupPointLocationFilters
    );
}

export function addPickupPointLocation(data) {
    return axios.post(urlDelivries + "/api/PickupPointLocation/", data);
}

export function editPickupPointLocation(data) {
    return axios.put(urlDelivries + "/api/PickupPointLocation/" + data.idPickupPointLocation, data);
}

export function deletePickupPointLocation(idLocation) {
    return axios.delete(urlDelivries + "/api/PickupPointLocation/" + idLocation);
}

export function getAllPickupPointLocation() {
    return axios.get(urlDelivries + "/api/PickupPointLocation/GetAll")
}